/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */
// Angular
import { NgModule, NgZone, Component, ElementRef, Renderer, Input, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
// Core
import { ControlComponent } from '../../core/component/control.component';
import { NgcErrorModule } from '../error/ngc-error.component';
// JQX Widget
import { jqxMaskedInputComponent } from 'jqwidgets-framework/jqwidgets-ts/angular_jqxmaskedinput';

// Control Value Accessor
const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => NgcMaskedInputComponent),
    multi: true
};

/**
 * Masked Input
 */

export class NgcMaskedInputComponent extends ControlComponent {
     mask: any;
     promptChar: any;
     readOnly: any;
     rtl: any;
     theme: any;
     textAlign: any;
     width: any;
     height: any;
     autoCreate: boolean = true;

    /**
     * Initialize
     */
    constructor(private ngZone: NgZone, private elementRef: ElementRef, private rendererRef: Renderer) {
        super(ngZone, elementRef, rendererRef);
    }

    /**
     * On Input Change
     * 
     * @param Event
     */
    inputChange($e) {
        this.value = $e.target.value;
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ngc-maskedinput',
    template: `<jqxMaskedInput *ngIf="visible" (onChange)="inputChange($event)"
                [disabled] = "disabled"
                [mask] = "mask"
                [promptChar] = "promptChar"
                [readOnly] = "readOnly"
                [rtl] = "rtl"
                [theme] = "theme"
                [textAlign] = "textAlign"
                [value] = "value"
                [width] = "width"
                [height] = "height">
                <ng-content></ng-content>
                </jqxMaskedInput>
                <ngc-error *ngIf="visible" [value]="error"></ngc-error>
                `,
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NgZone, },
{type: ElementRef, },
{type: Renderer, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'mask': [{ type: Input, args: ['mask', ] },],
'promptChar': [{ type: Input, args: ['promptChar', ] },],
'readOnly': [{ type: Input, args: ['readOnly', ] },],
'rtl': [{ type: Input, args: ['rtl', ] },],
'theme': [{ type: Input, args: ['theme', ] },],
'textAlign': [{ type: Input, args: ['textAlign', ] },],
'width': [{ type: Input, args: ['width', ] },],
'height': [{ type: Input, args: ['height', ] },],
'autoCreate': [{ type: Input, args: ['auto-create', ] },],
};
}

/**
 * MaskedInput Module
 */

export class NgcMaskedInputModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule, NgcErrorModule],
    exports: [NgcMaskedInputComponent],
    declarations: [NgcMaskedInputComponent, jqxMaskedInputComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
